
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Home, AlertTriangle } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
    
    // Collect additional diagnostic information
    const referrer = document.referrer;
    const userAgent = navigator.userAgent;
    
    console.log("404 Additional Info:", {
      referrer,
      userAgent,
      timestamp: new Date().toISOString(),
    });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
      <div className="bg-white rounded-lg shadow-md p-8 max-w-md w-full text-center">
        <AlertTriangle className="h-12 w-12 text-amber-500 mx-auto mb-4" />
        <h1 className="text-4xl font-bold mb-2 text-gray-800">404</h1>
        <p className="text-xl text-gray-600 mb-6">Página não encontrada</p>
        <p className="text-gray-500 mb-6">
          O endereço <span className="font-mono bg-gray-100 px-2 py-1 rounded">{location.pathname}</span> não existe em nosso sistema.
        </p>
        <div className="flex flex-col md:flex-row gap-4 justify-center">
          <Button
            variant="outline"
            className="flex items-center gap-2"
            onClick={() => window.history.back()}
          >
            <ArrowLeft className="h-4 w-4" /> Voltar
          </Button>
          <Link to="/">
            <Button className="flex items-center gap-2 w-full">
              <Home className="h-4 w-4" /> Página Inicial
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
